export default __webpack_public_path__ + "static/crooked-dee98fc7096e887b0ae52c1335c1a93f.png";